import React, { useState } from "react";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

interface Props {
  fieldRequired: boolean;
  setFieldsRequired: any;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SnackbarRequiredFieldError = (props: Props) => {
  const { fieldRequired, setFieldsRequired } = props;
  const [open, setOpen] = useState(fieldRequired);

  const onHandleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setFieldsRequired(false);
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar open={open} autoHideDuration={4000} onClose={onHandleClose}>
        <Alert
          onClose={onHandleClose}
          severity="error"
          sx={{ width: "100%", fontSize: "14px" }}
        >
          Complete los campos marcados como requeridos
        </Alert>
      </Snackbar>
    </Stack>
  );
};
